import * as React from 'react';
import FrameMain from 'theme/Frames/Main';

const MainFrameWrapper = (props): JSX.Element => {
    return <FrameMain />;
};

export default MainFrameWrapper;
